export const mainLearningCardData = [
    {
      learningCardBy: "Paige Turner",
      dateSpan: "05",
      date: "January 2024",
      hits: 15,
      language: "Java Language",
    },
    {
      learningCardBy: "Petey Cruiser",
      dateSpan: "10",
      date: "March 2024",
      hits: 36,
      language: "Web Development",
    },
  ];
  
  export const imagePaths = [
    {
      title: "Web Devlopment.",
      src: 3,
      text: "Perspiciatis unde omnis iste natus error sit.Dummy text",
    },
    {
      title: "Web Design.",
      src: 1,
      text: "Perspiciatis unde omnis iste natus error sit.Dummy text",
    },
    {
      title: "UX Development.",
      src: 4,
      text: "Perspiciatis unde omnis iste natus error sit.Dummy text",
    },
    {
      title: "Spoken English.",
      src: 2,
      text: "Perspiciatis unde omnis iste natus error sit.Dummy text",
    },
    {
      title: "Web Devlopment.",
      src: 4,
      text: "Perspiciatis unde omnis iste natus error sit.Dummy text",
    },
    {
      title: "Advance Design.",
      src: 3,
      text: "Perspiciatis unde omnis iste natus error sit.Dummy text",
    },
  ];
  
  export const learningFilterData = ["Accounting", "Design", "Development", "Management"];
  
  export const durationData = ["0-50 hours", "50-100 hours", "100+ hours"];
  
  export const priceCheckData = ["All Courses", "Paid Courses", "Free Courses"];
  
  export const statusCheckData = ["Registration", "Progress", "Completed"];
  
  export const designerCategoryData = [
    { learningHeading: "UI Design", badgeNumber: 28 },
    { learningHeading: "UX Design", badgeNumber: 35 },
    { learningHeading: "Interface Design", badgeNumber: 17 },
    { learningHeading: "User Experience", badgeNumber: 26 },
  ];
  
  export const developmentData = [
    { DevelopmentHeading: "Frontend Development", badgeNumber: 48 },
    { DevelopmentHeading: "Backend Development", badgeNumber: 19 },
  ];
  
  export const upcomingCourseData = [
    { courseHeading: "UX Development", courseDate: 18, courseMonth: "Dec", courseTeam: "Development Team" },
    { courseHeading: "Business Analyst", courseDate: 28, courseMonth: "Dec", courseTeam: "Analyst Team" },
    { courseHeading: "Web Development", courseDate: 5, courseMonth: "Jan", courseTeam: "Designer" },
  ];

  export const blogSingleData = [
    {
        id: 1,
        src: 'blog/12.png',
        name: 'Mark Jolio',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        paragraph: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    },
    {
        id: 2,
        src: 'blog/comment.jpg',
        name: 'Jolio Mark',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        paragraph: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    },
    {
        id: 3,
        src: "blog/14.png",
        name: 'Harf Mark',
        post: 'Designer',
        hits: '02 Hits',
        comments: '598 Comments',
        paragraph: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
    }
  ]